import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all } from "redux-saga/effects";

import api from "../../Environment";
import {
  changePostStatusFailure,
  changePostStatusSuccess,
  deletePostFailure,
  deletePostSuccess,
  fetchPostsFailure,
  fetchPostsSuccess,
  fetchSinglePostFailure,
  fetchSinglePostSuccess,
  fetchSinglePostStart,
  savePostFailure,
  savePostSuccess,
  PPVPaymentStripeFailure,
  PPVPaymentStripeSuccess,
  PPVPaymentWalletSuccess,
  PPVPaymentWalletFailure,
  saveReportPostSuccess,
  saveReportPostFailure,
  PPVPaymentPaypalFailure,
  PPVPaymentPaypalSuccess,
  postPaymentWalletSuccess,
  postPaymentWalletFailure,
  setSinglePost,
  updatePost,
  updatePostSuccess,
  updatePostTravelingLocationSuccess,
  updatePostTravelingLocationFailure,
  generatePostPreviewSuccess,
  generatePostPreviewFailure,
  acceptPostCollaborationSuccess,
  acceptPostCollaborationFailure,
  declinePostCollaborationSuccess,
  declinePostCollaborationFailure
} from "../actions/PostAction";
import {
  SAVE_POST_START,
  DELETE_POST_START,
  FETCH_POSTS_START,
  SAVE_REPORT_POST_START,
  FETCH_SINGLE_POST_START,
  CHANGE_POST_STATUS_START,
  PPV_PAYMENT_STRIPE_START,
  PPV_PAYMENT_WALLET_START,
  FETCH_REPORT_POSTS_START,
  PPV_PAYMENT_PAYPAL_START,
  POST_PAYMENT_WALLET_START,
  UPDATE_POST,
  UPDATE_POST_TRAVELING_LOCATION_START,
  GENERATE_POST_PREVIEW_START,
  ACCEPT_POST_COLLABORATION,
  DECLINE_POST_COLLABORATION
} from "../actions/ActionConstant";
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from "../../components/helper/NotificationMessage";
import postCollaborationService from "../../helpers/services/content/postCollaboration.service";
import { fetchNotificationsStart, resetNotificationData } from "../actions/NotificationAction";
import ErrorUtils from "../../helpers/utils/errors";
import { closeModal } from "../actions/ModalAction";
import { showErrorComponent } from "../actions/ComponentAction";
import { setHomePost } from "../actions/HomeAction";
import { setOtherUserSinglePost } from "../actions/OtherUserAction";
import { fetchWalletDetailsStart } from "../actions/WalletAction";

function * savePostAPI() {
  try {
    const inputData = yield select((state) => state.post.savePost.inputData);
    const { onUploadProgress, ...payload } = inputData

    if (!payload.content && !payload.post_files) {
      yield put(savePostFailure("Please fill the content"));
      const notificationMessage = getErrorNotificationMessage(
        "Please fill the content"
      );
      yield put(createNotification(notificationMessage));
    } else {
      const response = yield api.postMethod("posts_save_for_owner", payload, {
        onUploadProgress: (event) => {
          let progress = (event.loaded / event.total) * 100;
          onUploadProgress(Math.ceil(progress));
        }
      });
      if (response.data.success) {
        yield put(savePostSuccess(response.data.data));
        const notificationMessage = getSuccessNotificationMessage(
          response.data.message
        );
        yield put(createNotification(notificationMessage));
        window.location.assign("/post/" + response.data.data.post_unique_id);
      } else {
        yield put(savePostFailure(response.data.error));
        const notificationMessage = getErrorNotificationMessage(
          response.data.error
        );
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    yield put(savePostFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function * updatePostAPI() {
  try {
    const inputData = yield select((state) => state.post.updatePost.inputData);
    const { onUploadProgress, ...payload } = inputData

    if (!payload.content && !payload.post_files) {
      const notificationMessage = getErrorNotificationMessage(
        "Please fill the content"
      );
      yield put(createNotification(notificationMessage));
    } else {
      const response = yield api.postMethod("posts_update", payload, {});
      if (response.data.success) {
        const notificationMessage = getSuccessNotificationMessage(
          response.data.message
        );
        yield put(createNotification(notificationMessage));
        yield put(updatePostSuccess(response.data.data))
      } else {
        const notificationMessage = getErrorNotificationMessage(
          response.data.error
        );
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    const notificationMessage = getErrorNotificationMessage(error.message);
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(createNotification(notificationMessage));
  }
}

function* updatePostTravelingLocationAPI() {
  try {
    const inputData = yield select(
      (state) => state.post.updatePostTravelingLocation.inputData
    );
    const response = yield api.postMethod(
      "posts_update_traveling_location",
      inputData,
      {}
    );
    if (response.data.success) {
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(updatePostTravelingLocationSuccess(response.data.data));
      yield put(updatePostSuccess(response.data.data));
    } else {
      yield put(updatePostTravelingLocationFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(updatePostTravelingLocationFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    if (error?.response?.status !== 400) {
      yield put(
        showErrorComponent({
          error,
          status: error?.response?.status ? error?.response?.status : 500,
        })
      );
    }
    yield put(createNotification(notificationMessage));
  }
}

function* fetchPostsAPI() {
  try {
    const inputData = yield select((state) => state.post.posts.inputData);
    const response = yield api.postMethod("posts_for_owner", inputData);
    if (response.data.success) {
      yield put(fetchPostsSuccess(response.data.data));
    } else {
      yield put(fetchPostsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchPostsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchSinglePostAPI() {
  try {
    const inputData = yield select((state) => state.post.singlePost.inputData);
    const response = yield api.postMethod("posts_view_for_others", inputData);
    if (response.data.success) {
      yield put(fetchSinglePostSuccess(response.data.data));
    } else {
      yield put(fetchSinglePostFailure(response.data.error));
      if (response.data.error_code !== 139) {
        const notificationMessage = getErrorNotificationMessage(
          response.data.error
        );
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    yield put(fetchSinglePostFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* deletePostAPI() {
  try {
    const inputData = yield select((state) => state.post.delPost.inputData);
    const response = yield api.postMethod("posts_delete_for_owner", inputData);
    if (response.data.success) {
      yield put(deletePostSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      window.location.assign("/profile");
    } else {
      yield put(deletePostFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(deletePostFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* changePostStatusAPI() {
  try {
    const inputData = yield select(
      (state) => state.post.changePostStatus.inputData
    );
    const response = yield api.postMethod("posts_status", inputData);
    if (response.data.success) {
      yield put(changePostStatusSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(changePostStatusFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(changePostStatusFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* PPVPaymentPaypalAPI() {
  try {
    const paymentInputData = yield select(
      (state) => state.post.ppvPayPal.inputData
    );
    const response = yield api.postMethod(
      "posts_payment_by_paypal",
      paymentInputData
    );
    if (response.data.success) {
      yield put(PPVPaymentPaypalSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      window.location.assign("/post/" + response.data.data.post.post_unique_id);
    } else {
      yield put(PPVPaymentPaypalFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(PPVPaymentPaypalFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* PPVPaymentStripeAPI() {
  try {
    const paymentInputData = yield select(
      (state) => state.post.ppvPayStripe.inputData
    );
    const response = yield api.postMethod(
      "posts_payment_by_stripe",
      paymentInputData
    );
    if (response.data.success) {
      yield put(PPVPaymentStripeSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      window.location.assign("/post/" + response.data.data.post.post_unique_id);
    } else {
      yield put(PPVPaymentStripeFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(PPVPaymentStripeFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* PPVPaymentWalletAPI() {
  try {
    const paymentInputData = yield select(
      (state) => state.post.ppvPayWallet.inputData
    );
    const response = yield api.postMethod(
      "posts_payment_by_wallet",
      paymentInputData
    );

    if (response.data.success) {
      yield put(PPVPaymentWalletSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      window.location.assign("/post/" + response.data.data.post.post_unique_id);
    } else {
      yield put(PPVPaymentWalletFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(PPVPaymentWalletFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* saveReportPostAPI() {
  try {
    const inputData = yield select(
      (state) => state.post.saveReportPost.inputData
    );
    const response = yield api.postMethod("report_posts_save", inputData);
    if (response.data.success) {
      yield put(saveReportPostSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(saveReportPostFailure(response.data.error));
      const { notify, message } = ErrorUtils.handleApiError(response.data)
      if (notify) {
        yield put(createNotification(getErrorNotificationMessage(message)));
      }
    }
  } catch (error) {
    yield put(saveReportPostFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* postPaymentWalletAPI() {
  try {
    const inputData = yield select((state) => state.post.postPaymentWallet.inputData)
    const response = yield api.postMethod('posts_payment_by_wallet', inputData)
    if (response.data.success) {
      yield put(setHomePost(response.data.data))
      yield put(setSinglePost(response.data.data))
      yield put(setOtherUserSinglePost(response.data.data))
      yield put(postPaymentWalletSuccess(response.data.data))
      const notificationMessage = getSuccessNotificationMessage(response.data.message)
      yield put(closeModal())
      yield put(createNotification(notificationMessage))
      yield put(fetchWalletDetailsStart())
    } else {
      yield put(postPaymentWalletFailure(response.data.error))
      const notificationMessage = getErrorNotificationMessage(response.data.error)
      yield put(createNotification(notificationMessage))
    }
  } catch (error) {
    yield put(postPaymentWalletFailure(error))
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message)
    yield put(createNotification(notificationMessage))
  }
}

function* generatePostPreviewAPI(action) {
  try {
    const {payload, callback} =  action.data
    const response = yield api.postMethod("generate_preview", payload);

    if (response.data.success) {
      yield put(generatePostPreviewSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      callback()
    } else {
      yield put(generatePostPreviewFailure(response.data.error));
      const { notify, message } = ErrorUtils.handleApiError(response.data)
      if (notify) {
        yield put(createNotification(getErrorNotificationMessage(message)));
      }
    }
  } catch (error) {
    yield put(generatePostPreviewFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* acceptPostCollaborationAPI(action) {
  try {
    const { collaboration_request_id, repost_to_feed } = action.payload;
    const response = yield postCollaborationService.acceptPostCollaboration(collaboration_request_id, { repost_to_feed: repost_to_feed || false });
    if (response.status || response.success) {
      yield put(acceptPostCollaborationSuccess(response));
      const notificationMessage = getSuccessNotificationMessage("Collaboration request accepted successfully");
      yield put(createNotification(notificationMessage));
      yield put(resetNotificationData()); // Reset pagination to page 1
      yield put(fetchNotificationsStart());
    } else {
      yield put(acceptPostCollaborationFailure(response.error || response.message));
      const notificationMessage = getErrorNotificationMessage(response.error || response.message);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error || error?.response?.data?.message || error.message;
    yield put(acceptPostCollaborationFailure(error));
    const notificationMessage = getErrorNotificationMessage(errorMessage);
    yield put(createNotification(notificationMessage));
  }
}

function* declinePostCollaborationAPI(action) {
  try {
    const { collaboration_request_id, reason } = action.payload;
    const response = yield postCollaborationService.declinePostCollaboration(collaboration_request_id, { reason: reason || '' });
    if (response.status || response.success) {
      yield put(declinePostCollaborationSuccess(response));
      const notificationMessage = getSuccessNotificationMessage("Collaboration request declined successfully");
      yield put(createNotification(notificationMessage));
      yield put(resetNotificationData()); // Reset pagination to page 1
      yield put(fetchNotificationsStart());
    } else {
      yield put(declinePostCollaborationFailure(response.error || response.message));
      const notificationMessage = getErrorNotificationMessage(response.error || response.message);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error || error?.response?.data?.message || error.message;
    yield put(declinePostCollaborationFailure(error));
    const notificationMessage = getErrorNotificationMessage(errorMessage);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(SAVE_POST_START, savePostAPI)]);
  yield all([yield takeLatest(UPDATE_POST, updatePostAPI)]);
  yield all([
    yield takeLatest(
      UPDATE_POST_TRAVELING_LOCATION_START,
      updatePostTravelingLocationAPI
    ),
  ]);
  yield all([yield takeLatest(FETCH_POSTS_START, fetchPostsAPI)]);
  yield all([yield takeLatest(DELETE_POST_START, deletePostAPI)]);
  yield all([yield takeLatest(FETCH_REPORT_POSTS_START, fetchPostsAPI)]);
  yield all([yield takeLatest(SAVE_REPORT_POST_START, saveReportPostAPI)]);
  yield all([yield takeLatest(FETCH_SINGLE_POST_START, fetchSinglePostAPI)]);
  yield all([yield takeLatest(CHANGE_POST_STATUS_START, changePostStatusAPI)]);
  yield all([yield takeLatest(PPV_PAYMENT_STRIPE_START, PPVPaymentStripeAPI)]);
  yield all([yield takeLatest(PPV_PAYMENT_WALLET_START, PPVPaymentWalletAPI)]);
  yield all([yield takeLatest(PPV_PAYMENT_PAYPAL_START, PPVPaymentPaypalAPI)]);
  yield all([yield takeLatest(POST_PAYMENT_WALLET_START, postPaymentWalletAPI)]);
  yield all([yield takeLatest(GENERATE_POST_PREVIEW_START, generatePostPreviewAPI)]);
  yield all([yield takeLatest(ACCEPT_POST_COLLABORATION, acceptPostCollaborationAPI)]);
  yield all([yield takeLatest(DECLINE_POST_COLLABORATION, declinePostCollaborationAPI)]);
}
